<template>
  <div v-show="isSalesList" id="plan_table">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- ステータスモーダル -->
    <dd-plan-status-modal
      ref="planStatusRef"
      :isSalesList="isSalesList"
      @getSalesList="getSalesList"
    />
    <!-- 絞り込み検索モーダル -->
    <dd-plan-search-modal
      ref="planSearchRef"
      :isSalesList="isSalesList"
      @onClickSearch="onClickSearch"
    />
    <div class="table_wrapper">
      <!--  タイトルエリア  -->
      <div class="title_area">
        <h3 v-if="isSalesList">営業管理 → 受注処理</h3>
      </div>
      <div class="form_area">
        <div class="button_area">
          <button class="main_btn" @click="openSearchModal">絞り込み条件選択</button>
          <button class="main_btn" @click="downLoadCsv">CSV出力</button>
        </div>
        <!-- ページ -->
        <div>
          <dd-pager
            ref="pagerRef"
            :pageNo="pageNo"
            :dataCountPerPage="dataCount"
            :totalDataCount="totalCount"
            @paging="paging"
          />
        </div>
        <div class="disp_btn" @click="openDispModal">
          <div class="disp_icon">
            <span class="displogo"></span>
            <span class="displogo"></span>
            <span class="displogo"></span>
          </div>
          <div class="disptitle">表示項目</div>
        </div>
      </div>
      <!-- データテーブル -->
      <div class="plan_list_area">
        <table>
          <thead>
            <tr>
              <th class="check_area">変更</th>
              <th class="check_area">出力</th>
              <th class="check_area" :class="{none: checkDisp(0)}">ステータス</th>
              <th class="check_area" :class="{none: checkDisp(1)}">サービス名</th>
              <th :class="{none: checkDisp(2)}">確定納品日</th>
              <th :class="{none: checkDisp(3)}">納品希望日時</th>
              <th :class="{none: checkDisp(4)}">組立設置希望日１</th>
              <th :class="{none: checkDisp(5)}">組立設置希望日２</th>
              <th :class="{none: checkDisp(6)}">組立設置希望日３</th>
              <th :class="{none: checkDisp(7)}">注文日</th>
              <th :class="{none: checkDisp(8)}">見積日</th>
              <th :class="{none: checkDisp(9)}">プランID</th>
              <th :class="{none: checkDisp(10)}">プラン名</th>
              <th :class="{none: checkDisp(11)}">数量</th>
              <th :class="{none: checkDisp(12)}">発注会社名</th>
              <th :class="{none: checkDisp(13)}">発注者名</th>
              <th :class="{none: checkDisp(14)}">発注者ID</th>
              <th :class="{none: checkDisp(15)}">カテゴリー</th>
              <th :class="{none: checkDisp(16)}">シリーズ</th>
              <th :class="{none: checkDisp(17)}">プラン回数</th>
              <th :class="{none: checkDisp(18)}">コンバイン個数</th>
              <th :class="{none: checkDisp(19)}">ユニット個数</th>
              <th :class="{none: checkDisp(20)}">注文番号</th>
              <th :class="{none: checkDisp(21)}">注文個別番号</th>
              <th :class="{none: checkDisp(22)}">物件名</th>
              <th :class="{none: checkDisp(23)}">営業コメント</th>
              <th :class="{none: checkDisp(24)}">金額</th>
              <th :class="{none: checkDisp(25)}">商品代金</th>
              <th :class="{none: checkDisp(26)}">単価</th>
              <th class="ex_border" :class="{none: checkDisp(27)}">配送料</th>
              <th :class="{none: checkDisp(28)}">決済方法</th>
              <th :class="{none: checkDisp(29)}">納品先名</th>
              <th :class="{none: checkDisp(30)}">郵便番号</th>
              <th :class="{none: checkDisp(31)}">納品先住所</th>
              <th :class="{none: checkDisp(32)}">受取人氏名</th>
              <th :class="{none: checkDisp(33)}">受取人電話番号</th>
              <th class="ex_border" :class="{none: checkDisp(34)}">配送時の連絡事項</th>
              <th v-for="(num, index) in 10" :key="index" :class="{none: checkDisp(35 + index)}">{{ customNameList[num-1] }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(plan, index) in dispPlanDataList" :key="index"
            >
              <td class="check_area"><button class="list_btn blue_btn" @click="openStatusModal(plan)"></button></td>
              <td class="check_area"><button class="list_btn gray_btn" @click="openPreview(plan.spaceJoincd)"></button></td>
              <td class="check_area" :class="{none: checkDisp(0)}">{{ plan.planStatusLabel }}</td>
              <td class="check_area" :class="{none: checkDisp(1)}">{{ getServiceType(plan.serviceType) }}</td>
              <td :class="{none: checkDisp(2)}">{{ getFormatSimpleDate(plan.planDeliveryDate) }}</td>
              <td :class="{none: checkDisp(3)}">{{ getDateAndTime(plan.ecInfoDeliPref1, plan.ecInfoDeliPref1StTime, plan.ecInfoDeliPref1EndTime) }}</td>
              <td :class="{none: checkDisp(4)}">{{ getFormatSimpleDate(plan.ecInfoBtPref1) }}</td>
              <td :class="{none: checkDisp(5)}">{{ getFormatSimpleDate(plan.ecInfoBtPref2) }}</td>
              <td :class="{none: checkDisp(6)}">{{ getFormatSimpleDate(plan.ecInfoBtPref3) }}</td>
              <td :class="{none: checkDisp(7)}">{{ getFormatSimpleDate(plan.planOrderDate) }}</td>
              <td :class="{none: checkDisp(8)}">{{ getFormatSimpleDate(plan.planEstimateDate) }}</td>
              <td :class="{none: checkDisp(9)}">{{ plan.umPlanid }}</td>
              <td :class="{none: checkDisp(10)}">{{ plan.fileName }}</td>
              <td class="number_area" :class="{none: checkDisp(11)}">{{ plan.planCount }}</td>
              <td :class="{none: checkDisp(12)}">{{ plan.ecSnapCorpName }}</td>
              <td :class="{none: checkDisp(13)}">{{ plan.ecSnapPerson }}</td>
              <td :class="{none: checkDisp(14)}">{{ plan.ecSnapUserId }}</td>
              <td :class="{none: checkDisp(15)}">{{ plan.categoryName }}</td>
              <td :class="{none: checkDisp(16)}">{{ plan.seriesName }}</td>
              <td class="number_area" :class="{none: checkDisp(17)}">{{ plan.saveCount }}</td>
              <td class="number_area" :class="{none: checkDisp(18)}">{{ plan.combCount * plan.planCount }}</td>
              <td class="number_area" :class="{none: checkDisp(19)}">{{ plan.unitCount * plan.planCount}}</td>
              <td :class="{none: checkDisp(20)}">{{ plan.ecOrderNo }}</td>
              <td :class="{none: checkDisp(21)}">
                <span v-if="chkServiceType(plan.serviceType)" @click="goOrderDetail(plan.planOrderCode)"><a>{{ plan.planOrderCode }}</a></span>
                <span v-else>{{ plan.planOrderCode }}</span>
              </td>
              <td :class="{none: checkDisp(22)}">{{ plan.planPropertyName }}</td>
              <td :class="{none: checkDisp(23)}">{{ plan.planSalesComment }}</td>
              <td class="number_area" :class="{none: checkDisp(24)}">{{ plan.priceSales.toLocaleString() }}</td>
              <td class="number_area" :class="{none: checkDisp(25)}">{{ plan.priceProduct.toLocaleString() }}</td>
              <td class="number_area" :class="{none: checkDisp(26)}">{{ plan.priceUnit.toLocaleString() }}</td>
              <td class="ex_border" :class="{none: checkDisp(27)}">{{ plan.priceDelivery.toLocaleString() }}</td>
              <td :class="{none: checkDisp(28)}">{{ plan.ecInfoPayTypeStr }}</td>
              <td :class="{none: checkDisp(29)}">{{ plan.planDeliveryName }}</td>
              <td :class="{none: checkDisp(30)}">{{ plan.planDeliveryPostcd }}</td>
              <td :class="{none: checkDisp(31)}">{{ plan.planDeliveryAddress }}</td>
              <td :class="{none: checkDisp(32)}">{{ plan.planDeliveryPerson }}</td>
              <td :class="{none: checkDisp(33)}">{{ plan.planDeliveryTel }}</td>
              <td class="ex_border" :class="{none: checkDisp(34)}">{{ plan.planDeliverryNotice }}</td>
              <td :class="{none: checkDisp(35)}">{{ plan.planCustom1 }}</td>
              <td :class="{none: checkDisp(36)}">{{ plan.planCustom2 }}</td>
              <td :class="{none: checkDisp(37)}">{{ plan.planCustom3 }}</td>
              <td :class="{none: checkDisp(38)}">{{ plan.planCustom4 }}</td>
              <td :class="{none: checkDisp(39)}">{{ plan.planCustom5 }}</td>
              <td :class="{none: checkDisp(40)}">{{ plan.planCustom6 }}</td>
              <td :class="{none: checkDisp(41)}">{{ plan.planCustom7 }}</td>
              <td :class="{none: checkDisp(42)}">{{ plan.planCustom8 }}</td>
              <td :class="{none: checkDisp(43)}">{{ plan.planCustom9 }}</td>
              <td :class="{none: checkDisp(44)}">{{ plan.planCustom10 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import encoding from 'encoding-japanese'
import {API_URL, STORAGE_KEY} from '../../constants/App'
import {LIST_TYPE, SERVICE_TYPE, PLAN_STATUS} from '../../constants/Type'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import PlanOrderStatusModal from '../list/modal/PlanOrderStatusModal'
import PlanSearchModal from '../list/modal/PlanSearchModal'
import LoadingModal from '../common/LoadingModal'
import Pager from '../../components/common/OrderPager'

export default {
  name: 'SalesPlanTable',
  components: {
    'dd-plan-status-modal': PlanOrderStatusModal,
    'dd-plan-search-modal': PlanSearchModal,
    'dd-pager': Pager,
    'dd-loading-modal': LoadingModal
  },
  props: {
    isSalesList: Boolean,
    customNameList: Array,
    dispForm: Object
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      totalCount: 0,
      /** プランリスト全件 */
      planDataList: [],
      /** 表示用プランリスト */
      dispPlanDataList: [],
      /** 検索用顧客名 */
      selectBusinessName: '',
      /** 検索用案件名 */
      selectSubjectName: '',
      /** 処理日 */
      processingDate: '',
      /** 検索条件 */
      searchForm: {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      },
      defaultDispStatus: [
        PLAN_STATUS.UNDEFINED.code,
        PLAN_STATUS.SALES_A.code,
        PLAN_STATUS.SALES_B.code,
        PLAN_STATUS.SALES_C.code,
        PLAN_STATUS.ORDER.code,
        PLAN_STATUS.CANCEL.code,
        PLAN_STATUS.EC_CANCEL.code,
        PLAN_STATUS.EXCLUDED.code
      ]
    }
  },
  watch: {
    /** 営業管理リスト表示フラグ */
    isSalesList: function () {
      if (this.isSalesList) {
        document.addEventListener('mouseup', this.onMouseup)
      } else {
        document.removeEventListener('mouseup', this.onMouseup)
      }
    }
  },
  methods: {
    /** 営業管理リストを取得・表示 */
    getSalesList: function (isFirstView) {
      if (isFirstView) {
        this.pageNo = 1
        this.$refs.pagerRef.setCurrentPage(this.pageNo)
        this.clear()
      } else {
        this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      }
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** ステータスモーダルを開く */
    openStatusModal: function (plan) {
      this.$refs.planStatusRef.showModal(plan)
    },
    /** 絞り込み条件設定モーダルを開く */
    openSearchModal: function () {
      this.$refs.planSearchRef.showModal()
    },
    /** 表示項目切替モーダルを開く */
    openDispModal: function () {
      this.$emit('showDispModal')
    },
    /** 検索ボタン押下 */
    onClickSearch: function (searchForm) {
      this.pageNo = 1
      this.$refs.pagerRef.setCurrentPage(this.pageNo)
      searchForm.pageNo = this.pageNo
      searchForm.dataCount = this.dataCount
      this.onSearch(searchForm)
    },
    /** 絞り込み条件で検索 */
    onSearch: function (searchForm) {
      App.setLocalStorage(STORAGE_KEY.PLAN_SEARCH, searchForm)
      this.$refs.loadingModalRef.showModal(true)
      if (searchForm.planStatus.length === 0) {
        searchForm.planStatus = this.defaultDispStatus
      }
      axios.post(API_URL.LIST + '/sales', searchForm)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.planDataList = response.data.data.columnDataList
          this.dispPlanDataList = this.planDataList
          this.totalCount = response.data.data.totalCount
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 項目の表示・非表示判定 */
    checkDisp: function (num) {
      return !this.dispForm.salesCheckList.includes(num)
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm = App.getLocalStorage(STORAGE_KEY.PLAN_SEARCH)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 出力プレビューの表示 */
    openPreview: function (joincd) {
      let childWindow = window.open('/#/preview?spaceJoincd=' + joincd, 'sheet-page', 'width=1420, height=940')
      childWindow.location.reload()
    },
    /** CSV出力 */
    downLoadCsv: function () {
      axios.get(API_URL.LIST + '/download/' + LIST_TYPE.SALES.code)
        .then(response => {
          let formatStr = moment().format('YYYYMMDDHHmmss')
          let arrayData = response.data.data
          let csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          // SJISに変換する
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'SalesList_' + formatStr + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clear: function () {
      this.searchForm = {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        businessName: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      }
    },
    /** サービス名を取得 */
    getServiceType: function (num) {
      switch (num) {
        case SERVICE_TYPE.DAROS.code:
          return SERVICE_TYPE.DAROS.label
        case SERVICE_TYPE.MMSTYLE.code:
          return SERVICE_TYPE.MMSTYLE.label
        case SERVICE_TYPE.KAGULL.code:
          return SERVICE_TYPE.KAGULL.label
        case SERVICE_TYPE.YASUMOKU.code:
          return SERVICE_TYPE.YASUMOKU.label
        default:
          return ''
      }
    },
    chkServiceType: function (num) {
      if (num === SERVICE_TYPE.MMSTYLE.code) {
        return true
      } else {
        return false
      }
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    getFormatSimpleDate: function (date) {
      if (date) {
        return moment(date).format('M/DD')
      } else {
        return ''
      }
    },
    getDateAndTime: function (date, start, end) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      if (!start || !end) {
        time += ' 時間指定なし'
      } else {
        time += start < 12 ? ' AM ' : ' PM '
        time += start + ':00'
        time += '～'
        time += end + ':00'
      }
      return time
    },
    goOrderDetail: function (orderCode) {
      this.$router.push({
        name: 'OrderDetail',
        query: {id: orderCode}
      })
    }
  },
  mounted: function () {
    this.processingDate = this.getFormatDate(new Date())
  },
  beforeDestroy: function () {
    document.removeEventListener('mouseup', this.onMouseup)
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#plan_table {
  height: 95%;
  width: 95%;
  padding: 10px 30px;
}
.title_area {
  color: #4472C4;
  background-color: #F3ECD9
}
table {
  td {
    a {
      color: blue;
    }
    a:hover {
      color: #ff4500;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/SalesPlanTable.vue